// extracted by mini-css-extract-plugin
module.exports = {"cont":"BtnBox_cont__2Se6j"};